module.exports = __webpack_public_path__ + "static/media/engajamento-abrapp.270b6065.png";